export const useGo7seasLogo = (publicId = "go7seas-logo") => {
  if (useRuntimeConfig().public.environment !== "production") {
    return "test-logo";
  }

  return publicId;
};
